import type { ParticipantView } from "../../shared/types.ts";
import "./participant-incentive.css";

/** The source-authored reward receipt follows only this session's progress. */
export function ParticipantIncentive({
  incentive,
}: {
  incentive: NonNullable<ParticipantView["incentive"]>;
}) {
  const progress = incentive.placement === "progress";
  return (
    <aside
      className="pe-incentive"
      data-testid="participant-incentive"
      data-placement={incentive.placement}
      aria-label="Your reward"
    >
      {progress && (
        <>
          <p className="pe-incentive__amount">
            <strong>
              {incentive.currency}
              {incentive.earned}
            </strong>
            <span>
              {" "}
              of {incentive.currency}
              {incentive.total} earned
            </span>
          </p>
          <progress
            value={incentive.earned}
            max={incentive.total || 1}
            aria-label="Reward earned"
          />
        </>
      )}
      <p className="pe-incentive__message">{incentive.message}</p>
      {incentive.placement === "landing" && (
        <p className="pe-incentive__detail">
          Paid out at the end of the session
        </p>
      )}
    </aside>
  );
}
